<pre class="prettyprint" [innerHTML]="value | prettyprint"></pre>
